import WaitForRedirect from "@casino/legacy/client/shared/WaitForRedirect";
import useAuth0Callback from "./useAuth0Callback";

const Auth0Callback: FC = () => {
  const { logo } = useAuth0Callback();

  return <WaitForRedirect logo={logo} />;
};

export default Auth0Callback;
